module.exports = __webpack_public_path__ + "static/media/reports.81a99065.svg";